import React from 'react'
import styles from './index.module.less'
import { useNavigate } from 'react-router-dom'
const data = [
  { id: 1, title: '闭门案例分析与展示', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet1.png' },
  { id: 2, title: '合作伙伴吸引互动', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet2.png' },
  { id: 3, title: '辐射带动能力提升', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet3.png' },
  { id: 4, title: '拓展高层人脉', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet4.png' },
  { id: 5, title: '加速战略部署', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet5.png' },
  { id: 6, title: '完善市场布局、巩固行业地位', img: 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/meet6.png' },
]
export default function Meeting() {
  const navigate = useNavigate()
  return (
    <div style={{ width: "100%", backgroundColor: '#F4F9FE' }}>
      <div className={styles.cont}>
        <span className={styles.big_title}>品牌介绍</span>
        <p style={{ marginTop: '50px' }}>iMFG是长期专注于中国及亚太区域制造科技发展与创新的高端商务社交品牌，通过系列峰会与展览，持续影响并赋能包括钢铁、汽车零部件、机械、汽车、轻工业等十大重点行业在内的众多制造企业，深度连接产业链中下游，用科技重塑业务流程、提升业务运转效率，驱动企业长远发展。
        </p>
        <p>我们以切实项目供需、实时案例分析、精准决策沟通、实质项目合作推进为核心，以时下热门丰富主题为牵引，嵌入行业重点领域和关键环节，赋能制造企业及其决策团队，推动产业技术变革和优化升级。
        </p>
        <img src="https://gw.alipayobjects.com/mdn/rms_08e378/afts/img/A*xOYlR4e8ihIAAAAAAAAAAABkARQnAQ" alt="" />
        <div className={styles.card}>
          {
            data.map(i => (
              <div className={styles.item} key={i.id}>
                <img src={i.img} alt="" />
                <span>{i.title}</span>
              </div>
            ))
          }
        </div>
        {/* <button onClick={() => { navigate('/enroll') }}>申请演讲</button> */}
        <button onClick={() => { window.location.href="http://t1.ink/f/py0rt3" }}>申请演讲</button>
      </div>
    </div>
  )
}
